import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "../styles/footer.css";

/* small "verified" badge used as the recurring structural device —
   nods to CodeMatrix's verified-profile identity instead of decorating
   with generic numbering or icons */
function Verified() {
  return (
    <span className="cm-footer__verified" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="11" height="11">
        <path
          fill="currentColor"
          d="M9 16.2l-3.5-3.5L4 14.2l5 5 11-11-1.5-1.5z"
        />
      </svg>
    </span>
  );
}

export default function Footer() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <footer className={`cm-footer${isMobile ? " cm-footer--compact" : ""}`}>
      <div className="cm-footer__inner">
     

        <div className="cm-footer__grid">
          {/* --- brand column --- */}
          <div className="cm-footer__col cm-footer__col--brand">
            <img
              className="cm-footer__logo"
              src="/codematrixLogo.png"
              alt="CodeMatrix Logo"
            />
            <p className="cm-footer__about">
              The world&rsquo;s first Skill Intelligence platform built for
              the 2026 hiring landscape. We transform how technical talent is
              measured, developed, and hired&mdash;one verified profile at a
              time.
            </p>
          </div>

          {/* --- navigation column --- */}
          <div className="cm-footer__col">
            <h4 className="cm-footer__heading">
              {/* <Verified /> */}
             Company
            </h4>
            <nav className="cm-footer__links">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/courses">Courses</Link>
              <Link to="/company">Company</Link>
              <Link to="/contact">Contact</Link>
            </nav>
          </div>

          {/* --- socials column --- */}
          <div className="cm-footer__col">
            <h4 className="cm-footer__heading">
              {/* <Verified /> */}
              Socials
            </h4>
            <nav className="cm-footer__links">
              <a
                href="https://www.facebook.com/profile.php?id=61585464100913"
                target="_blank"
                rel="noopener noreferrer"
              >
                Facebook <span className="cm-footer__arrow">&#8599;</span>
              </a>
              <a
                href="https://www.linkedin.com/company/110879705"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn <span className="cm-footer__arrow">&#8599;</span>
              </a>
              <a
                href="https://www.instagram.com/codematrix2026/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Instagram <span className="cm-footer__arrow">&#8599;</span>
              </a>
            </nav>
          </div>

          {/* --- contact column --- */}
          <div className="cm-footer__col">
            <h4 className="cm-footer__heading">
              {/* <Verified /> */}
              Contact
            </h4>
            <ul className="cm-footer__contact">
              <li>
                <i className="fa fa-map-marker" aria-hidden="true"></i>
                <span>BSI Business Park, H-140, Noida Sector-63</span>
              </li>
              <li>
                <i className="fa fa-phone" aria-hidden="true"></i>
                <a href="tel:+917302227370">+91 7302227370</a>
              </li>
              <li>
                <i className="fa fa-envelope" aria-hidden="true"></i>
                <a href="mailto:hrinfo@predictbyte.com">hrinfo@predictbyte.com</a>
              </li>
            </ul>
          </div>
        </div>

        {/* --- featured on --- */}
        <div className="cm-footer__featured">
          <span className="cm-footer__heading cm-footer__heading--inline">
            <Verified />
            Featured on
          </span>
          <div className="cm-footer__badges">
            <a
              href="https://fazier.com/launches/codematrix.co.in"
              target="_blank"
              rel="noopener noreferrer"
              className="cm-footer__badge"
            >
              <img
                src="https://fazier.com/api/v1//public/badges/launch_badges.svg?badge_type=featured&theme=light"
                width={180}
                alt="Fazier badge"
              />
            </a>
            <a
              href="https://www.producthunt.com/products/codematrix?embed=true&utm_source=badge-featured&utm_medium=badge&utm_campaign=badge-codematrix"
              target="_blank"
              rel="noopener noreferrer"
              className="cm-footer__badge"
            >
              <img
                width="180"
                height="39"
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1146891&theme=light&t=1778760230670"
                alt="CodeMatrix - Master coding interviews with AI | Product Hunt"
              />
            </a>
          </div>
        </div>

        {/* --- bottom bar --- */}
        <div className="cm-footer__bottom">
          <p className="cm-footer__copyright">&copy; 2026 CodeMatrix</p>
          {/* <p className="cm-footer__status">
            <span className="cm-footer__status-dot" aria-hidden="true"></span>
            v2026.1 &middot; operational
          </p> */}
        </div>
      </div>

      {/* signature: oversized ghost wordmark, cropped by the footer edge */}
      {/* <div className="cm-footer__ghost" aria-hidden="true">
        CodeMatrix
      </div> */}
    </footer>
  );
}